import * as React from 'react'
import './index.scss'
import clear from '../../images/clear.svg';

export interface keyItem {
    value: any,
    type?: string,
    action?: string
}

interface IProps {
    onChange: ((item: keyItem) => void)
}

interface IState {
    activeIndex: number
}

const keys = [
    {value: '1'}, {value: '2'}, {value: '3'},
    {value: '4'}, {value: '5'}, {value: '6'},
    {value: '7'}, {value: '8'}, {value: '9'},
    {value: '.'}, {value: '0'}, {value: clear, type: 'image', action: 'delete'},
]

class NumberPad extends React.Component<IProps, IState> {
    constructor(props:IProps){
        super(props)
        this.state = {
            activeIndex: -1
        }
    }
    handleTouchStart = (index: number) : void => {
        this.setState({activeIndex: index})
    }
    handleTouchEnd = () => {
        // console.log('end:',e)
        this.setState({activeIndex: -1})
    }
    public render() {
        return (<div className="NumberPad">
            {keys.map((item, i) => {
                return (<div onClick={()=>this.props.onChange(item)}
                             onTouchStart={()=>this.handleTouchStart(i)}
                             onTouchEnd={this.handleTouchEnd}
                             key={`number-pad-${i}`}
                             className={`keyItem ${i === this.state.activeIndex ? 'active' : ''}`}>
                    {item.type === 'image' ?
                        <img src={item.value} alt={item.action || item.value}/>
                        : <span>{item.value}</span>
                    }
                </div>)
            })}
        </div>);
    }
}

export default NumberPad